import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import EmployeeDashboard from "@/pages/employee/EmployeeDashboard";
import AttendancePage from "@/pages/employee/AttendancePage";
import ReimbursementPage from "@/pages/employee/ReimbursementPage";
import CashAdvancePage from "@/pages/employee/CashAdvancePage";
import RFQPage from "@/pages/employee/RFQPage";
import ProfilePage from "@/pages/employee/ProfilePage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import EmployeeDetail from "@/pages/admin/EmployeeDetail";
import AttendanceAdminPage from "@/pages/admin/AttendanceAdminPage";
import RFQAdminPage from "@/pages/admin/RFQAdminPage";

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/attendance"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />

            <Route path="/dashboard" element={<ProtectedRoute role="employee"><EmployeeDashboard /></ProtectedRoute>} />
            <Route path="/attendance" element={<ProtectedRoute role="employee"><AttendancePage /></ProtectedRoute>} />
            <Route path="/reimbursement" element={<ProtectedRoute role="employee"><ReimbursementPage /></ProtectedRoute>} />
            <Route path="/cash-advance" element={<ProtectedRoute role="employee"><CashAdvancePage /></ProtectedRoute>} />
            <Route path="/rfq" element={<ProtectedRoute role="employee"><RFQPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute role="employee"><ProfilePage /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/attendance" element={<ProtectedRoute role="admin"><AttendanceAdminPage /></ProtectedRoute>} />
            <Route path="/admin/rfqs" element={<ProtectedRoute role="admin"><RFQAdminPage /></ProtectedRoute>} />
            <Route path="/admin/employee/:id" element={<ProtectedRoute role="admin"><EmployeeDetail /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
